<template>
  <div>
    <div class="Fuell-Toolbar">
      <ul class="Fuell-Tabs">
        <li class="Fuell-Tabs--tab">
          <router-link
            to="/profile/details"
            class="Fuell-Tabs--link"
            active-class="active"
            v-t="{path:'user_profile_personal_details_tab'}"
          ></router-link>
        </li>

        <li
          class="Fuell-Tabs--tab"
          v-if="!isSuperadminOrCommercial"
        >
          <router-link
            to="/profile/preferences"
            class="Fuell-Tabs--link"
            active-class="active"
            v-t="{path:'user_profile_preferences_tab'}"
          ></router-link>
        </li>

      </ul>

      <button
        class="Fuell-ToolbarButton orange ml-auto"
        @click="handleLogout"
      >
        <span class="Fuell-ToolbarButton--label"> {{$t(logoutButtonLabel)}}</span>
      </button>
    </div>

    <router-view></router-view>

  </div>
</template>

<script>

export default {
  name: 'UserProfileIndex',

  methods: {
    handleLogout () {
      if (this.$store.getters['LoginStore/isImpersonating']) {
        this.$store.dispatch('LoginStore/stopImpersonation')
      } else {
        this.$store.dispatch('LoginStore/logout')
        this.$store.dispatch('UsersStore/logout')
      }
    },
    async fetchCurrentUser () {
      if (this.loggedUserId) {
        await this.$store.dispatch('UsersStore/fetchUserLogged', this.loggedUserId)
      }
    }
  },
  async created () {
    await this.fetchCurrentUser()
  },
  computed: {
    loggedUserId () {
      return this.$store.getters['LoginStore/loggedUserId'] ? this.$store.getters['LoginStore/loggedUserId'] : false
    },
    isCallingUsers () {
      return this.$store.getters['UsersStore/isCallingUsers']
    },
    logoutButtonLabel () {
      return this.$store.getters['LoginStore/isImpersonating'] ? 'ACTION_IMPERSONATE_STOP' : 'ACTION_LOGOUT'
    },
    isSuperadminOrCommercial () {
      return this.$store.getters['LoginStore/isSuperAdmin'] || this.$store.getters['LoginStore/isCommercial']
    }
  },
  watch: {
    loggedUserId: {
      handler: 'fetchCurrentUser',
      immediate: true
    }
  }

}
</script>

<style scoped>
@media screen and (max-width:576px) {
  .Fuell-ToolbarButton {
    width:100%;
  }
  .Fuell-ToolbarButton--label {
    text-align: center;
    width:100%;
  }
}
</style>
